import {
  Blockchain,
  type BlockchainConfig,
} from "@anaconda/core/blockchain/types"
import { useMolecule } from "bunshi/react"
import { useCurrency } from "../currency/store/use-currency-price"
import { ApplicationEnvironmentMolecule } from "../env/store"
import { BlockchainsMoleculeReatom } from "./blockchain-molecule.reatom"
import { getClientSolanaFallbackConfig } from "./required-client-blockchains"

export function useBlockchains() {
  const { blockchains } = useMolecule(BlockchainsMoleculeReatom)
  const blockchainsData = blockchains()
  const blockchainData = blockchainsData.data

  return blockchainData
}

export function useBlockchain(blockchain: Blockchain) {
  const blockchainData = useBlockchains()
  const { hostEnvironment } = useMolecule(ApplicationEnvironmentMolecule)
  const network = blockchainData?.networks.find(
    (n: BlockchainConfig) => n.blockchain === blockchain,
  )

  if (network) {
    return network
  }

  if (blockchain === Blockchain.SOLANA) {
    return getClientSolanaFallbackConfig(hostEnvironment)
  }

  throw new Error(`Blockchain ${blockchain} is not supported`)
}

export function useNativeCurrency(blockchain: Blockchain) {
  const network = useBlockchain(blockchain)
  const currency = useCurrency(network?.primaryCurrency.id)

  return currency
}

export function useWrappedCurrency(blockchain: Blockchain) {
  const network = useBlockchain(blockchain)
  const currency = useCurrency(network?.wrappedCurrency?.id)

  return currency
}
